<template>
  <div class="otoCon">
    <template v-if="listData.length > 0">
      <div
        v-for="(item,index) in listData"
        :key="index"
        class="broadcastotoList"
        style="position: relative;"
      >
        <div
          class="boradcastmark"
          v-if="item.broadcast_show == 0"
        >
        <p style="font-size: 16px;font-weight: bold;color: #424242;" :style="lan=='ch'?'':'line-height: 30px;margin-top: 75px;'">{{language.LiveRoomShowTip}}</p>
          <!--开启关闭直播间按钮-->
          <!-- <el-button
            type="primary"
            @click="showBroadcast(item,index,1)"
            style="margin-left:0 !important;"
          >

            <p v-if="item.broadcast_show == 0">
              <span v-if="lan == 'ch'">显示</span>
              <span v-else>SHOW</span>
            </p>
          </el-button> -->
          <!-- <p v-if="item.broadcast_show == 1">
                <span v-if="lan == 'ch'">隐藏</span>
                <span v-else>HIDE</span>
              </p> -->


        </div>

        <div class="broadcastotoListop">
          <div class="opopic">
            <img
              v-if="item.broadcast_logo"
              :src="item.broadcast_logo+'?imageMogr2/thumbnail/130x130'"
              style="width: 100%;height: 100%;object-fit: contain;"
            />
            <img
              v-else
              src="../../../../assets/img_default_logo.png"
              style="width: 100%;height: 100%;object-fit: contain;"
            />


          </div>
          <div class="opooinfo">
            <div  class="opooinfoName">{{item.create_key}}.{{item.broadcast_name}}</div>
<!--            <div v-else class="opooinfoName">{{item.create_key}}.{{item.broadcast_name_en || item.broadcast_name}}</div>-->

            <div class="opooinfosm">
              <ul>
                <li>{{item.exh_name}}</li>
                <li>{{item.periodTime}}</li>
<!--                <li v-else>{{item.exh_name_en}}</li>-->
              </ul>
            </div>

            <div class="opooinfobt">
              <ul>
<!--                <li-->
<!--                  class="opooinfobt_info_li"-->
<!--                  style="width: 83px"-->
<!--                >-->
<!--                  <el-tooltip-->
<!--                    class="item"-->
<!--                    effect="dark"-->
<!--                    :content="lan=='ch'?item.location:item.location_en"-->
<!--                    placement="top-start"-->
<!--                  >-->
<!--                  <div v-if="lan=='ch'" class="opooinfobt_info_li">{{item.location || item.location_en}}</div>-->
<!--                  <div v-else class="opooinfobt_info_li">{{item.location_en || item.location}}</div>-->
<!--                  </el-tooltip>-->
<!--                </li>-->
<!--                <li-->
<!--                  class="opooinfobt_info_li"-->
<!--                  style="width: 181px"-->
<!--                >-->
<!--                  <el-tooltip-->
<!--                    class="item"-->
<!--                    effect="dark"-->
<!--                    :content="lan=='ch'?item.company:item.company_en"-->
<!--                    placement="top-start"-->
<!--                  >-->
<!--                  <div v-if="lan=='ch'" class="opooinfobt_info_li">{{item.company || item.company_en}}</div>-->
<!--                  <div v-else class="opooinfobt_info_li">{{item.company_en || item.company}}</div>-->
<!--                  </el-tooltip>-->
<!--                </li>-->
                <li
                  class="opooinfobt_info_li"
                  style="width: 118px"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="(lan=='ch'?(item.user_post||item.user_post_en):(item.user_post_en||item.user_post))+':'+(lan=='ch'?(item.truename||item.truename_en):(item.truename_en||item.truename))"
                    placement="top-start"
                  >
                  <div class="opooinfobt_info_li">{{item.user_post || item.user_post_en}}：{{item.truename || item.truename_en}}</div>
                  </el-tooltip>
                </li>
<!--                <li-->
<!--                  class="opooinfobt_info_li"-->
<!--                  style="width: 83px"-->
<!--                >-->
<!--                  <el-tooltip-->
<!--                    class="item"-->
<!--                    effect="dark"-->
<!--                    :content="lan=='ch'?(item.broadcast_class_name||item.broadcast_class_name_en):(item.broadcast_class_name_en ||item.broadcast_class_name)"-->
<!--                    placement="top-start"-->
<!--                  >-->
<!--                  <div v-if="lan=='ch'" class="opooinfobt_info_li">{{item.broadcast_class_name || item.broadcast_class_name_en}}</div>-->
<!--                  <div v-else class="opooinfobt_info_li">{{item.broadcast_class_name_en || item.broadcast_class_name}}</div>-->
<!--                  </el-tooltip>-->
<!--                </li>-->
                 <li class="opooinfobt_info_li" style="width: 220px">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="language.liveClass3 + ':' +tipJob[index]"
                    placement="top-start"
                  >
                    <div class="opooinfobt_info_li">{{language.liveClass3}}：
                      <span v-for="p in item.jobList"
                            v-if="p.jobc_super_name != null && p.jobc_super_name != ''"
                            style="margin-right: 10px;">{{p.jobc_super_name}}•{{p.name}} </span>
                    </div>
                  </el-tooltip>
                </li>
                <li
                  class="opooinfobt_info_li"
                  style="width: 220px;margin-right: 0"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="language.contact+'：'+userInfo.email"
                    placement="top-start"
                  >
                    <div class="opooinfobt_info_li">{{language.contact}}：{{userInfo.email}}</div>
                  </el-tooltip>
                </li>
              </ul>
            </div>
          </div>


        </div>
        <div
          class="broadcastotoLisBtn"
          v-if="item.exh_bstate != 3"
        >
          <!-- <el-button
            type="primary"
            @click="showBroadcast(item,index,1)"
            style="background: #003f8f;margin-left:0 !important;"
            v-if="item.broadcast_show == 1"
          >
            <p v-if="item.broadcast_show == 1">
              <span v-if="lan == 'ch'">隐藏</span>
              <span v-else>HIDE</span>
            </p>
          </el-button> -->

            <!-- <p v-if="item.broadcast_show == 0">
                <span v-if="lan == 'ch'">显示</span>
                <span v-else>SHOW</span>
              </p> -->
          <!-- 我要布展 -->
          <el-tooltip
            class="item"
            effect="dark"
            :content="language.editExhnotes"
            placement="top"
          >
            <el-button
              type="warning"
              @click="editData(item.broadcast_id,item)"
              style="background-color: #f47900;margin-left: 0;"
            >{{language.editExh}}</el-button>
          </el-tooltip>
          <!--席位管理-->
          <el-tooltip
            class="item"
            effect="dark"
            :content="language.seatManagementTip"
            placement="top"
          >
            <el-button
              type="primary"
              @click="seatManagement(item)"
              style="background: #FFFFFF;border: solid 1px #f47900;color: #f47900;"
              :style="lan=='ch'?'':'width: 125px;'"
            >{{language.seatManagement}}</el-button>
          </el-tooltip>
          <!-- 手机海报分享 -->
          <el-button
            type="primary"
            @click="showImg(item)"
            v-if="lan == 'ch'"
            style="background: #FFFFFF;border: solid 1px #0071ff;color: #0071ff;"
          >手机海报分享</el-button>
          <!-- <el-tooltip
            class="item"
            effect="dark"
            :content="language.appointmentsotes"
            placement="top"
          > -->
            <!--查看预约-->
            <!-- <el-button
              type="primary"
              :style="lan=='ch'?'':'width: 155px;'"
              @click="handleSee(item)"
              style="background: #003f8f"
            >{{language.appointments}}</el-button>-->
          <!-- </el-tooltip> -->


          <!-- <el-tooltip class="item" effect="dark" :content="language.appointmentnotes" placement="top">
              <el-button type="primary" @click="showSetPanle(true,item)" style="background: #003f8f">{{language.appointment}}</el-button>
            </el-tooltip> -->




          <!--            <el-button type="primary" @click="handleSeeOfflineAppointments(item)" style="background: #003f8f">{{language.seeOfflineAppointments}}</el-button>-->

          <!-- 增加直播间 -->
          <el-button
            type="primary"
            style="background: #FFFFFF;border: solid 1px #0071ff;color: #0071ff;"
            @click="addRoom(item)"
          >{{language.addRoom}}</el-button>
          <el-tooltip
            class="item"
            effect="dark"
            :content="language.enterExhnotes"
            placement="top"
          >
            <!----------进入直播---------->
            <el-button
              type="primary"
              @click="joinData(item.broadcast_id,item)"
              style="background-color: #0071ff"
            >{{language.enterExh}}</el-button>
          </el-tooltip>
          <!-- 回放 -->
          <el-button
            type="primary"
             @click="handlePlayback(item)"
            style="background-color: #005bcd;width: 70px;"
          >回放</el-button>
          <!-- 回放 -->
          <el-button
            type="primary"
            style="background-color: #f47900;"
              @click="handleSee(item)"
          >面试人员列表</el-button>
          <!-- style="margin-left:0 !important;" -->
          <!-- 开启关闭翻译 -->
          <!-- <el-button
            type="primary"
            v-if="item.translate == 0"
            :style="lan=='ch'?'width: 160px;':'width: 255px;'"
            @click="showBroadcast(item,index,1)"
          >
            <p>
              <span v-if="lan == 'ch'">打开翻译（付费使用）</span>
              <span v-else>Turn On Translation(Pay per minute)</span>
            </p>
          </el-button>  -->
          <!-- <el-button
            type="primary"
            v-if="item.translate != 0"
            :style="lan=='ch'?'':'width: 145px;'"
            @click="showBroadcast(item,index,1)"
          >
            <p>
              <span v-if="lan == 'ch'">关闭翻译</span>
              <span v-else>Turn Off Translation</span>
            </p>
          </el-button>  -->
        </div>

        <div
          class="broadcastotoLisBtn"
          v-if="item.exh_bstate == 3"
        ></div>

        <div
            class="tips"
            v-if="userInfos.check_status==0">
          您的公司信息等待审核，暂时无法在前台显示</div>
        <div
            class="tips"
            v-if="userInfos.check_status==2">
          您的公司信息审核未通过，暂时无法在前台显示</div>

        <!--布展和未布展-->
        <div style="position: absolute;right: -57px;top: 45px;">
          <img v-if="item.is_modify == 0" src="../../../../assets/img/weibuzhan.png">
          <img v-if="item.is_modify == 1" src="../../../../assets/img/yibuzhan.png">
          <span style="color: #FFFFFF;font-size: 16px;letter-spacing: 1px;position: relative;right: 70px;top: -13px;">{{item.is_modify == 0 ? '未布展' : '已布展'}}</span>
        </div>


      </div>
    </template>
    <template style="position: relative;" v-else>
<!--      <error-card :language="language" />-->
      <img src="../../../../assets/img/wu.png" style="margin-top: 10px;">
      <span style="color: #999999;font-size: 16px;position: absolute;left: 608px;top: 490px;">还没有发布任何消息</span>
    </template>
    <!--查看预约弹窗-->
    <drag-dialog
      :show.sync="dialogShow"
      :title="title"
      :columns="columns"
      :language="language"
      :fn="stateEnum.SEEAPPOINTMENT"
      :init-cont="initCount"
      width="520px"
      :linkButton="yuyue"
      :goto-link="golink"
    />

    <!--查看线下预约弹窗-->
    <!-- <drag-dialog
        :show.sync="dialogOfflineAppointmentsShow"
        :title="title"
        :columns="columns"
        :language="language"
        :fn="stateEnum.OFFLINEAPPOINTMENTS"
        :init-cont="initCount"
        width="520px"
      /> -->
    <!--查看排队弹窗-->
    <drag-dialog
      :show.sync="dialogLineUpShow"
      :title="title"
      :columns="PDcolumns"
      :language="language"
      :fn="stateEnum.LINEHISTORY"
      :init-cont="initCount"
      width="520px"
      :linkButton="linkbutton"
      :goto-link="golink"
    />
    <appList
      :title="appTitle"
      :dialogVisible="listshow"
      :roomid="broadcast_id"
      @handleclose="handleclose"
    >
    </appList>
    <drag-dialog
      :show.sync="dialogVisible"
      :choose="choose"
      :language="language"
      :columns="columnCz"
      width="550px"
      title="回放列表"
      :fn="parseInt(1)"
      @select-cz-info="handleCzInfo"
      :initCont="initCont"
    >
    </drag-dialog>
  </div>
</template>
<script>
  import {videoUrl} from "@/common/url";
import errorImage from "../../../../assets/error_room.png";
import errorCard from "../errorCard/index";
import dragDialog from "../../../../components/DragDialog/index";
import { stateEnum } from "../../attendancerecord/enum";
import appList from "../appoint/index";
import Cookie from "../../../../common/cookie";
import { getPrevBrocastInfo } from "@/api/forum";
import reqest from "@/common/reqest";
import {mapGetters} from "vuex";
import {getUserInfo} from "@/api/user";
  import {getMyExhibition} from "@/api/btManage";
  import {selectList} from "@/api/exhibition";
  import {MessageBox} from "element-ui";
  import {language} from "@/language/get";
export default {
  components: {
    errorCard,
    dragDialog,
    appList,
  },
  computed: {
    ...mapGetters(["token", "userInfo"]),
  },
  props: {
    listData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    language: {
      type: Object,
      default: () => {
        return {};
      },
    },
    perfectMess: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      exhMess:null,
      userInfos:{check_status: null}, //信息
      appTitle:"",
      tipJob:[],
      listshow: false,
      choose: '',
      dialogVisible: false,
      initCont: {}, //弹窗初始化内容
      columnCz: [
        {
          title: '日期',
          key: "time",
          width: "370"
        },
        {
          title: '操作',
          key: "action",
          width: '140'
        }
      ],  //回放
      yuyue: false,
      linkbutton: false,
      lan: Cookie.get("lang"),
      errorImage,
      stateEnum,
      listDataCom:null,
      showSet: false,
      exh_days_json: [],
      setName: "",
      dialogShow: false,
      dialogOfflineAppointmentsShow: false,
      title: "",
      broadcast_id: 0,
      exhibition_id: 0,
      initCount: null,
      columns: [
        {
          title: this.language.name,
          key: Cookie.get("lang") == "ch" ? "true_name" : "true_name_en",
          width: "105",
        },
        {
          title: this.language.hintContact,
          key: "tel",
          width: "110",
        },
        {
          title: this.language.companyName,
          key: Cookie.get("lang") == "ch" ? "company" : "company_en",
          width: "150",
        },
        {
          title: this.language.subiectTime,
          key: "use_time",
          width: "auto",
        },
      ],
      PDcolumns: [
        {
          title: this.language.name,
          key: Cookie.get("lang") == "ch" ? "true_name" : "true_name_en",
          width: "105",
        },
        {
          title: this.language.hintContact,
          key: "tel",
          width: "130",
        },
        {
          title: this.language.companyName,
          key: Cookie.get("lang") == "ch" ? "company" : "company_en",
          width: "auto",
        },
      ],
      dialogLineUpShow: false,
      LiveRoomLineList: [],
      golink: "",
    };
  },
  watch:{
    listData:function(val) {
      // console.log("什么数据==" , val);
      this.listDataCom = val;
      this.tipJob = [];
      for(var item in this.listDataCom) {
        let jobname = "";
        for(var i in this.listDataCom[item].jobList) {
          if(this.listData[item].jobList[i].jobc_super_name != null){
            jobname += this.listDataCom[item].jobList[i].jobc_super_name + "•" + this.listDataCom[item].jobList[i].name;
            jobname += " ";
          }
        }
        this.tipJob.push(jobname);
      }
      // console.log("监视==" , this.tipJob);
      // console.log("监视==" , val);
      // console.log("提示工作=" + this.tipJob);
    }


  },
  mounted() {
    selectList({type: "", keyword: "", ckeyword: "",currentPage: 1}).then((res)=>{
      this.exhMess = res.data;
      // console.log("招聘会=" , res);
    });
    // console.log("相关信息===" , this.listData)
    // console.log(this.language.subiectTime);
    // for(var item in this.listData) {
    //   for(var i in this.listData[item].jobList) {
    //     // if(this.listData[item].jobList[i].jobc_super_name != null){
    //       this.tipJob += this.listData[item].jobList[i].jobc_super_name + "•" + this.listData[item].jobList[i].name;
    //       this.tipJob += " ";
    //     // }
    //
    //   }
    // }
    // console.log("提示工作=" + this.tipJob);
    // console.log("信息完善" + this.perfectMess);
    // this.userInfo.check_status = 2;
    this.getUserMess();
  },
  methods: {
    //回放
    handlePlayback(data) {
      this.choose="playback";
      this.initCont = data;
      this.dialogVisible = true;
    },
    handleCzInfo(row, initCont, fn) {
      const props = {
        roomid: initCont.broadcast_id,
        broadcast_playback_id: row.broadcast_playback_id
      };
      window.open(videoUrl(props));
      // window.location.href = videoUrl(props);
    },
    //获取信息
    getUserMess(){
      getUserInfo().then((res)=> {
        if (res.type != '1') {
          return this.$message.error({message: res.text, offset: 120})
        }else {
          this.userInfos = res.data[0];
          // console.log("公司信息===" , this.userInfos)
        }
      });
    },
    seatManagement(item){
      this.$emit("seatManagement", item);
    },
    handleclose(e) {
      this.listshow = e;
    },
    toogleSet(d) {
      this.showSet = d;
    },
    showSetPanle(d, item) {
      this.showSet = d;
      this.setName = item.broadcast_name + this.language.Schedule;
      this.exh_days_json = item.exh_days_json;
      this.broadcast_id = item.broadcast_id;
      this.exhibition_id = item.exhibition_id;
    },
    //1修改 2进入
    editData(id, item) {
      // console.log(item,'itemitem')
      this.$emit("changData", 1, id, item);
      //   let param = {
      //     token:this.$store.state.user.token,
      //   }
      //     getPrevBrocastInfo(param).then((res)=>{

      //   // console.log(res.data,'resresresres')
      //         if(item.keyword != ""){
      //            this.$emit('changData',1, id,item)
      //         }else{
      //           if(res.data){
      //            res.data['broadcast_id'] = item.broadcast_id;
      //            this.$emit('changData',1, id,res.data)
      //           }else{
      //            this.$emit('changData',1, id,item)
      //           }
      //         }
      //     });
    },
    joinData(id,item) {
      this.$emit("joinData", 2, id,item);
    },
    showImg(item) {
      this.$emit("showImg", item);
    },
    addRoom(item) {
      let equality = false;
      this.exhMess.forEach(i=>{
        if(i.exhibition_id == item.exhibition_id && i.exh_type == 3){
          equality = true;
        }
      });
      if(equality) {
        MessageBox({
          title: "",
          message: "招聘会已结束，不能增加直播间",
          confirmButtonText: language().confirm,
          cancelButtonText: language().cancel,
          showCancelButton: false,
        }).then(() => {
          //确认
        }).catch(() => {
          //取消
        });
        return;
      }
      // console.log("增加直播间=" , item);

      if(this.userInfo.superioruser_id != 0){
        this.$message.error({message:"子账号没有权限增加直播间" , offset:200})
        return;
      }else {
        let encodeData = window.btoa(window.encodeURIComponent("exhibitionId=" + item.exhibition_id + "&flag=1"));
        window.location.href = "ticketsRegister.html?" + encodeData;
      }
      localStorage.setItem("buyBackUrl", location.href);
      let encodeData = window.btoa(window.encodeURIComponent("exhibitionId=" + item.exhibition_id + "&flag=1"));
      window.location.href = "ticketsRegister.html?" + encodeData;

    },
    // 开启关闭直播间
    showBroadcast(item, index, flag) {
      this.$emit("showBroadcast", item, index, flag);
    },
    //查看预约
    handleSee(val) {
      this.broadcast_id = val.broadcast_id;
      this.appTitle = '招聘列表-'+val.broadcast_name;
      this.handleclose(true);
    },
    handleSeeOfflineAppointments(val) {
      this.title = this.language.newWatch + "-" + val.broadcast_name;
      this.initCount = val;
      this.dialogOfflineAppointmentsShow = true;
    },

    //查看排队历史
    handleLineSee(val) {
      this.linkbutton = true;
      this.title = this.language.newWatch + "-" + val.broadcast_name;
      this.initCount = val;
      this.dialogLineUpShow = true;

      this.golink =
        reqest.apiUrl+"/Home/Pub/RoomListExport?lan=" +
        this.lan +
        "&roomid=" +
        val.broadcast_id;
    },
    //查看联系方式
    // selectContact(item){
    //   this.$emit("selectContact", item)
    // }
  },
};
</script>
<style>
.boradcastmark {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  line-height: 220px;
  text-align: center;
  box-shadow: 0px 5px 6px rgba(205, 205, 205, 0.7);
  box-sizing: border-box;
  border-radius: 5px;
  white-space: pre-wrap;
}
.broadcastoto .otoCon {
  min-height: 260px;
  padding-bottom: 50px;
}
.broadcastoto .broadcastotoList {
  width: 100%;
  /*background: #fff;*/
  margin-top: 10px;
  /*box-shadow: 0px 5px 6px rgba(205, 205, 205, 0.7);*/
  padding: 22px;
  box-sizing: border-box;
  /*border-radius: 5px;*/
  /*width: 993px;*/
  /*height: 200px;*/
  background-color: #ffffff;
  border-radius: 5px;

}
.broadcastoto .broadcastotoList .broadcastotoListop {
  display: flex;
}
.broadcastoto .broadcastotoList .opopic {
  width: 130px;
  height: 130px;
  /*flex: 1;*/
}
.broadcastoto .broadcastotoList .opopic img {
  width: 100%;
  height: 100%;
}
.broadcastoto .broadcastotoList .opooinfo {
  margin-left: 21px;
  /*flex: 4;*/
}
.broadcastoto .broadcastotoList .opooinfo .opooinfoName {
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #0071ff;
  font-family: SourceHanSansCN-Bold;
}
.broadcastoto .broadcastotoList .opooinfo .opooinfosm,
.broadcastoto .broadcastotoList .opooinfo .opooinfobt {
  margin: 20px 0;
  font-size: 16px;
  /*color: #424242;*/
  color: #333333;
}
.broadcastoto .broadcastotoList .opooinfo .opooinfosm ul,
.broadcastoto .broadcastotoList .opooinfo .opooinfobt ul {
  display: flex;
  align-items: center;
}
.broadcastoto .broadcastotoList .opooinfo .opooinfosm ul li {
  margin-right: 40px;
}
.broadcastoto .broadcastotoList .opooinfo .opooinfobt ul li {
  margin-right: 20px;
}
.broadcastoto .broadcastotoList .broadcastotoListxt {
  font-size: 14px;
  color: #a1a1a1;
  margin: 20px 0;
}
.broadcastoto .broadcastotoList .broadcastotoLisBtn {
  margin-top: 15px;
  text-align: left;
}
.broadcastoto .broadcastotoList .broadcastotoLisBtn button {
  text-align: right;
  width: 110px;
  height: 40px;
  border-radius: 5px;
  border: none;
  padding: 0;
  font-size: 14px;
  text-align: center;
  margin-left: 20px;
  /*background: none !important;*/
  color: #FFFFFF;
  /*border: 1.5px solid #003f8f;*/
  font-weight: 600;
}
.broadcastoto .broadcastotoList .broadcastotoLisBtn button:nth-of-type(2) {
  background: none;
  /* border: 1px solid #003f8f;
  color: #003f8f; */
}
.broadcastoto .broadcastotoList .broadcastotoLisBtn button:nth-of-type(3) {
  background: none;
  /* border: 1px solid #ff9e00;
  color: #ff9e00; */
}
.opooinfobt_info_li {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.broadcastoto .broadcastotoList .broadcastotoLisBtn button{
  margin-left: 10px;
}
.tips {
  color: #ff0000;
  font-size: 14px;
  margin-top: 10px;
  margin-left: 10px;
}
</style>
